<template>
  <div class="page flex-col">
    <div class="box_1 flex-col">
      <div class="block_1 flex-row">
        <span class="text_13">面试时长：</span>
        <div class="section_3 flex-row">
          <span class="text_14">1小时</span>
          <img
            class="thumbnail_5"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng32bb5ffc73b63ed9396c4ca5c88708cf949f1f38de2bf548b59a76f324c084d7.png"
          />
        </div>
      </div>
    </div>
    <div class="box_20 flex-col">
      <div class="block_3 flex-col"></div>
      <div class="text-wrapper_1 flex-col"><span class="text_5">开始面试</span></div>
      <div class="block_4 flex-col">
        <div class="block_5 flex-col">
          <div class="text-wrapper_2 flex-col"><span class="text_6">你好！面试可以开始了吗</span></div>
        </div>
      </div>
      <div class="block_6 flex-col">
        <div class="section_4 flex-row justify-between">
          <span class="text_7">设置</span>
          <div class="image-wrapper_4 flex-col">
            <img
              class="thumbnail_6"
              referrerpolicy="no-referrer"
              src="./assets/img/SketchPng5b8557aa5cd1d3d242a57174707ee895be082eb8bb725b046460306200cfeae9.png"
            />
          </div>
        </div>
        <div class="box_4 flex-col"></div>
        <div class="section_5 flex-row justify-between">
          <div class="block_7 flex-col">
            <div class="box_6 flex-row">
              <div class="image-text_18 flex-row justify-between">
                <img
                  class="thumbnail_3"
                  referrerpolicy="no-referrer"
                  src="./assets/img/SketchPngad37d8ebfbfd45234cd97aedad75bfaf5a51235ac6ee020a4b5fa5f2aa45a90a.png"
                />
                <span class="text-group_1">对比</span>
              </div>
            </div>
            <div class="box_7 flex-row">
              <span class="text_8">标准</span>
              <div class="section_1 flex-col"><div class="box_8 flex-col"></div></div>
              <span class="text_9">0</span>
            </div>
          </div>
          <div class="group_6 flex-col">
            <div class="box_9 flex-row">
              <span class="text_10">虚拟背景</span>
              <span class="text_11">美颜</span>
              <div class="text-wrapper_3 flex-col"><span class="text_12">滤镜</span></div>
            </div>
            <div class="box_21 flex-row justify-between">
              <div class="image-text_19 flex-col justify-between">
                <div class="image-wrapper_2 flex-col">
                  <img
                    class="label_1"
                    referrerpolicy="no-referrer"
                    src="./assets/img/SketchPng1075886d6776a3a51fe7bb067ddc243955aaa5c277f2878810c5b072210d931d.png"
                  />
                </div>
                <span class="text-group_2">不使用</span>
              </div>
              <div class="image-text_20 flex-col justify-between">
                <div class="image-wrapper_3 flex-col">
                  <img
                    class="thumbnail_4"
                    referrerpolicy="no-referrer"
                    src="./assets/img/SketchPngdd8fa49c98a04bdaa1f883a4ae2c83c199f4e3afc2b1543e119d665929f89a6f.png"
                  />
                </div>
                <span class="text-group_3">标准</span>
              </div>
              <div class="image-text_21 flex-col justify-between">
                <div class="section_2 flex-col"></div>
                <span class="text-group_4">樱红</span>
              </div>
              <div class="image-text_22 flex-col justify-between">
                <div class="group_1 flex-col"></div>
                <span class="text-group_5">云雾</span>
              </div>
              <div class="image-text_23 flex-col justify-between">
                <div class="group_2 flex-col"></div>
                <span class="text-group_6">纯真</span>
              </div>
              <div class="image-text_24 flex-col justify-between">
                <div class="group_3 flex-col"></div>
                <span class="text-group_7">白兰</span>
              </div>
            </div>
            <div class="box_22 flex-row justify-between">
              <div class="image-text_25 flex-col justify-between">
                <div class="box_12 flex-col"></div>
                <span class="text-group_8">元气</span>
              </div>
              <div class="image-text_26 flex-col justify-between">
                <div class="group_4 flex-col"></div>
                <span class="text-group_9">超脱</span>
              </div>
              <div class="image-text_27 flex-col justify-between">
                <div class="group_5 flex-col"></div>
                <span class="text-group_10">香氛</span>
              </div>
              <div class="image-text_28 flex-col justify-between">
                <div class="box_13 flex-col"></div>
                <span class="text-group_11">美白</span>
              </div>
              <div class="image-text_29 flex-col justify-between">
                <div class="box_14 flex-col"></div>
                <span class="text-group_12">浪漫</span>
              </div>
              <div class="image-text_30 flex-col justify-between">
                <div class="box_15 flex-col"></div>
                <span class="text-group_13">清晰</span>
              </div>
            </div>
            <div class="box_23 flex-row justify-between">
              <div class="image-text_31 flex-col justify-between">
                <div class="box_17 flex-col"></div>
                <span class="text-group_14">唯美</span>
              </div>
              <div class="image-text_32 flex-col justify-between">
                <div class="block_9 flex-col"></div>
                <span class="text-group_15">粉嫩</span>
              </div>
              <div class="image-text_33 flex-col justify-between">
                <div class="box_18 flex-col"></div>
                <span class="text-group_16">怀旧</span>
              </div>
              <div class="image-text_34 flex-col justify-between">
                <div class="box_19 flex-col"></div>
                <span class="text-group_17">蓝调</span>
              </div>
            </div>
          </div>
        </div>
        <div class="section_6 flex-row justify-between">
          <div class="text-wrapper_4 flex-col"><span class="text_15">取消</span></div>
          <div class="text-wrapper_5 flex-col"><span class="text_16">确认</span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />